import * as React from 'react';
import { colors } from '../ui/theme';

export default function SectionBreak({
  length = '1rem',
  width = 1,
  placement = 'Bottom',
}: {
  length?: string;
  width?: number;
  placement?: 'Bottom' | 'Top';
}) {
  const borderX = placement === 'Bottom' ? ['borderBottom'] : ['borderTop'];
  return (
    <div
      style={{
        paddingBottom: length,
        [borderX[0]]: `${width}px solid ${colors.gray100}`,
      }}
    />
  );
}
